
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFB600","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M14.979 1.725H8.04a.43.43 0 00-.428.429.43.43 0 00.428.428h6.938a.43.43 0 00.428-.428.43.43 0 00-.428-.429zM17.09.038a.43.43 0 00-.43.428v3.338a.43.43 0 00.43.428.43.43 0 00.428-.428V.466a.43.43 0 00-.429-.428zM6 .038a.43.43 0 00-.428.428v3.338A.43.43 0 006 4.232a.43.43 0 00.429-.428V.466A.43.43 0 006 .038zM19.891 6.975H3.193a.43.43 0 00-.429.429.43.43 0 00.429.428h16.693a.431.431 0 00.434-.428.43.43 0 00-.429-.429zM15.991 10.35H3.193a.43.43 0 00-.429.429.43.43 0 00.429.428h12.798a.426.426 0 00.429-.428.43.43 0 00-.429-.429zM10.425 13.671H3.193a.43.43 0 00-.429.43.43.43 0 00.429.428h7.232a.43.43 0 00.429-.429.43.43 0 00-.429-.429z"}}),_c('path',{attrs:{"d":"M25.516 15.638a5.734 5.734 0 00-2.427-2.427V2.132a.401.401 0 00-.396-.407h-3.916a.43.43 0 00-.429.429.43.43 0 00.429.428h3.455v10.264a5.523 5.523 0 00-1.794-.289c-3.15 0-5.711 2.55-5.711 5.706 0 .605.096 1.21.295 1.783H.857V2.582H3.75a.43.43 0 00.429-.428.43.43 0 00-.429-.429H.413A.4.4 0 000 2.132v18.364a.396.396 0 00.386.408h15a5.711 5.711 0 007.698 2.432 5.711 5.711 0 002.432-7.698zm-5.073 7.494a4.858 4.858 0 110-9.718 4.858 4.858 0 110 9.718z"}}),_c('path',{attrs:{"d":"M23.02 18.118h-2.127v-2.909a.43.43 0 00-.429-.429.43.43 0 00-.428.429v3.337a.405.405 0 00.396.424h2.588a.425.425 0 100-.852z"}})])])
          )
        }
      }
    